export default __webpack_public_path__ + "static/media/banquet.77a0a7b9.svg";